export default __webpack_public_path__ + "static/media/Mobile Screenshot 2.721bcc53.png";